var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('v-property-status-list',{attrs:{"property-id":_vm.model.id,"property":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }